import { render, staticRenderFns } from "./SLRDecision.vue?vue&type=template&id=e5ea21a2&scoped=true&"
import script from "./SLRDecision.vue?vue&type=script&lang=ts&"
export * from "./SLRDecision.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ea21a2",
  null
  
)

export default component.exports